import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { loginConfirm } from '../../common/loginConfirm';
import styles from './MyPageNavigate.module.scss';
function MyPageNavigate() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  return (
    <ul className={styles.navigationWrap}>
      <li
        onClick={() => {
          navigate('/basket');
        }}
        className={location.pathname == '/basket' ? styles.hit : ''}
      >
        {t('myPage.19')}
      </li>
      <li
        onClick={() => {
          if (!loginConfirm()) return;
          navigate('/point');
        }}
        className={location.pathname == '/point' ? styles.hit : ''}
      >
        {t('myPage.2')}
      </li>
      <li
        onClick={() => {
          if (!loginConfirm()) return;
          navigate('/pick');
        }}
        className={location.pathname == '/pick' ? styles.hit : ''}
      >
        {t('myPage.3')}
      </li>
      <li
        onClick={() => {
          if (!loginConfirm()) return;
          navigate('/coupon');
        }}
        className={location.pathname == '/coupon' ? styles.hit : ''}
      >
        {t('myPage.4')}
      </li>
      <li
        onClick={() => {
          if (!loginConfirm()) return;
          navigate('/myReview');
        }}
        className={location.pathname == '/myReview' ? styles.hit : ''}
      >
        {t('myPage.5')}
      </li>
      <li
        onClick={() => {
          if (!loginConfirm()) return;
          navigate('/updateProfile');
        }}
        className={location.pathname == '/updateProfile' ? styles.hit : ''}
      >
        {t('myPage.27')}
      </li>
      {/* <li
        onClick={() => {
          if (!loginConfirm()) return;
          navigate('/myCard');
        }}
        className={location.pathname == '/myCard' ? styles.hit : ''}
      >
        간편카드등록
      </li> */}
    </ul>
  );
}
export default MyPageNavigate;
